import { ViewerPageTableLine } from '../types'

export const getChildrenNumber = (
  children: ViewerPageTableLine[] = []
): number => {
  let sum = 0
  children.forEach(child => {
    sum += getChildrenNumber(child.children) || 1
  })
  return sum || children.length
}
